import React from 'react'

const ShimmerCard = () => { 
  return (
      <div className="flex flex-wrap">
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div>    
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div>   
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div>
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div>
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div>
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
        <div className="bg-gray-200 p-2 m-3 h-48 w-72 rounded-xl">  
        </div> 
      </div> 
  )
}

export default ShimmerCard
